import { GrWorkshop } from 'react-icons/gr';
import { FaHandHoldingHeart, FaHandshake, FaPeopleCarry } from 'react-icons/fa';
import { SiHandshake } from 'react-icons/si';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { BsPersonCheckFill, BsFillClipboard2DataFill } from 'react-icons/bs';
import { MdFolderSpecial, MdOutlineHandshake } from 'react-icons/md';


export const UsInfoItems = [
  {
    id: 1,
    name: 'Talento',
    icon: GrWorkshop
  },
  {
    id: 2,
    name: 'Calidad humana al servicio de la organización de eventos',
    icon: FaPeopleCarry
  },
  {
    id: 3,
    name: 'Respeto',
    icon: SiHandshake
  },
  {
    id: 4,
    name: 'Compromiso con cada cliente',
    icon: FaHandshake
  },
  {
    id: 5,
    name: 'Innovación',
    icon: HiOutlineLightBulb
  },
  {
    id: 6,
    name: 'Amantes al detalle',
    icon: MdFolderSpecial
  },
  {
    id: 7,
    name: 'Experiencia',
    icon: BsPersonCheckFill
  },
  {
    id: 8,
    name: 'Orientación a Resultados',
    icon: BsFillClipboard2DataFill
  },
  {
    id: 9,
    name: 'Confianza',
    icon: MdOutlineHandshake
  },
  {
    id: 10,
    name: 'Pasión',
    icon: FaHandHoldingHeart
  },
]

